export default function (props: any) {
    return (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="15" y="15" width="23" height="18" rx="1.16667" stroke="black" strokeWidth="2" />
            <rect x="44" y="47" width="21" height="18" rx="1.16667" stroke="black" strokeWidth="2" />
            <rect x="15" y="39" width="23" height="26" rx="1.16667" stroke="black" strokeWidth="2" />
            <rect x="44" y="15" width="21" height="26" rx="1.16667" stroke="black" strokeWidth="2" />
        </svg>
    );
}
